import { RouteConfig } from "vue-router";
import localizationFactory from "@/router/modules/localization-factory";

export default {
	name: "",
	path: '/payment-requirements',
	component: () => import('../views/PaymentRequirementsList.vue'),
	children: [
		{
			path: "incoming/:tab?",
			name: "paymentRequirementsIncoming",
			meta: localizationFactory('paymentRequirements.incoming', {
				className: "header-sm-none"
			}),
			component: () => import('../views/IncomingPaymentRequirementsList.vue'),
		},
		{
			path: "outgoing",
			name: "paymentRequirementsOutgoing",
			meta: localizationFactory('paymentRequirements.outgoing', {
				className: "header-sm-none"
			}),
			component: () => import('../views/OutgoingPaymentRequirementsList.vue'),
		},
		{
			path: 'incoming-pay',
			name: 'paymentRequirementsIncomingPay',
			meta: localizationFactory('home.tabsList.titlePayment', {
				className: "header-sm-none"
			}),
			component: () => import('../views/IncomingPaymentRequirementsPay.vue'),
		},
		{
			path: "creation",
			name: "paymentRequirementsCreation",
			meta: localizationFactory('paymentRequirements.outgoing', {
				layout: "main",
				className: "header-sm-none"
			}),
			component: () => import('../views/PaymentRequirementsCreation.vue')
		},
	]
} as RouteConfig;